module.exports = new __parcel__URL__("mega-texture.85bd0e29.png").toString();